// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConsultaCep_ReversaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ConsultaCep_ReversaResponseDados {
cep: string
logradouro: string
bairro: string
localidade: string
uf: string
complemento: string
}

export type ConsultaCep_ReversaResponse = ApiResponse<ConsultaCep_ReversaResponseDados>;

registerResponseContract('ConsultaCep_ReversaResponse', {
  cep:         { type: 'string',  required: true },
  logradouro:  { type: 'string',  required: true },
  bairro:      { type: 'string',  required: true },
  localidade:  { type: 'string',  required: true },
  uf:          { type: 'string',  required: false },
  complemento: { type: 'string',  required: false },
})
